// extracted by mini-css-extract-plugin
export var cartContainer = "_nz-4";
export var gray = "_nz-1";
export var itemContainer = "_nz-2";
export var itemDetails = "_nz-3";
export var strong = "_nz-0";